import classNames from "classnames";
import styles from "./AscImageGroup.module.scss";
import { useDrop } from "react-dnd";
import { QuizDraggableActivityItem } from "@ascendnow/shared";
import AscGenericCard from "../../../AscCards/AscGenericCard/AscGenericCard";

export interface AscImageGroupProps {
  className?: string;
  wrapperClassName?: string;
  id: string;
  title: string;
  loading?: boolean;
  children?: React.ReactNode;
  correct?: boolean;
}

export default function AscImageGroup({
  className,
  wrapperClassName,
  id,
  title,
  children,
  loading = false,
  correct = undefined,
}: AscImageGroupProps) {
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: QuizDraggableActivityItem,
    drop: () => ({ id }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));
  return (
    <div className={classNames(styles.wrapper, wrapperClassName)} ref={drop}>
      <AscGenericCard
        title={title}
        coverImageUrl={null}
        data-testid="asc-image-group-dropzone"
        loading={loading}
        bodyClassName={styles.body}
        titleClassName={styles.title}
        contentClassName={styles.content}
        className={classNames(
          styles.ground,
          {
            [styles.isOver]: isOver,
            [styles.canDrop]: canDrop,
            [styles.correct]: correct === true,
            [styles.incorrect]: correct === false,
          },
          className
        )}
      >
        <div className={styles.dropZone}>{children}</div>
      </AscGenericCard>
    </div>
  );
}
